// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
// import Swiper core and required modules
import SwiperCore, { Pagination } from "swiper";

import './Style.css';

// install Swiper modules
SwiperCore.use([Pagination]);

export const SmallSwiper = () => {
    return (
        <div className="w-full">
            <Swiper pagination={true} className="mySwiper" loop={true}>
                <SwiperSlide>
                    <div className="flex flex-col justify-center items-center">
                        <div className="title-swip">
                            ¡Bienvenido!
                        </div>
                        <div className="sentence-swip">
                            En esta aplicación podrás encontrar todos los servicios que el hotel tiene para ti.
                        </div>
                    </div>

                </SwiperSlide>
                <SwiperSlide>
                    <div className="flex flex-col justify-center items-center">
                        <div className="title-swip">
                            Editar Loren ipsum
                        </div>
                        <div className="sentence-swip">
                            Revisa detalles, realiza pagos, realiza tu
                            check in y más
                        </div>
                    </div>

                </SwiperSlide>
                <SwiperSlide>
                    <div className="flex flex-col justify-center items-center">
                        <div className="title-swip">
                            Editar Loren ipsum
                        </div>
                        <div className="sentence-swip">
                            Puedes navegar por la aplicación libremente, sin embargo; si eres huésped podrás acceder a todas las secciones de la aplicación.
                        </div>
                    </div>

                </SwiperSlide>
            </Swiper>
        </div>
    )
}
